import { render, staticRenderFns } from "./empTaxationConf.vue?vue&type=template&id=47a0b97a&scoped=true&"
import script from "./empTaxationConf.vue?vue&type=script&lang=js&"
export * from "./empTaxationConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a0b97a",
  null
  
)

export default component.exports